import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import {inputSettlement} from 'src/api'; 
import { connect, MyStore } from 'kts-platform-frame/redux';
import {Modal} from 'antd';
import { history } from 'kts-platform-frame/routes';


class ModulesAction extends ActionBasic<ModulesState> {

    public getList = async(params: any) => {
        if ( params["minCreateTime"]   && typeof params["minCreateTime"] !== 'string'){
            params["minCreateTime"] = params["minCreateTime"].format("YYYY-MM-DD");
        }
        if ( params["maxCreateTime"]  && typeof params["maxCreateTime"] !== 'string') {
            params["maxCreateTime"] = params["maxCreateTime"].format("YYYY-MM-DD");
        }
        
        const receiptList: any = await inputSettlement.list(this, params);
        if(receiptList.er){
            return ;
        }
        this.modulesState.receiptList = receiptList.res.items;
        if (receiptList.res.pageMeta) {
            this.modulesState.pageMeta.total = receiptList.res.pageMeta.total;
            this.modulesState.pageMeta.pages = receiptList.res.pageMeta.pages;
        }
        this.setModulesState(this.modulesState);
    }
    /**
     * 进项结算单列表页
     * 初始化分页器
     * @memberof ModulesAction
     */
    public initPaging = () => {
        let _pageNum;
        if (this.modulesState.pageMeta){
             _pageNum = this.modulesState.pageMeta.pageNum === 1 ? 1 : this.modulesState.pageMeta.pageNum;
        }
        
        this.modulesState.pageMeta ={
            pageNum: _pageNum || 1,
            pageSize: 10,
            pages: 0,
            total: 0,
        };
        this.modulesState.current === 1 ? 1: this.modulesState.current;
        this.setModulesState(this.modulesState);
    }

    /**
     * 进项结算单列表页
     * 清空表单，初始化到第一页
     * @memberof ModulesAction
     */
    public resetFields = () => {
        this.modulesState.current = 1;
        this.modulesState.fields = null;
        this.setModulesState(this.modulesState);
        console.log(this.modulesState.fields);
    }
    
    /**
     * 进项结算单列表页
     * 分页器切换页面处理
     * @memberof ModulesAction
     */
    public onPageChange = async(page: number) => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        if (this.modulesState.fields) {
            this.getList({companyId,pageSize:10, pageNum: page, ...this.modulesState.fields});
        } else {
            this.getList({companyId,pageSize:10, pageNum: page});
        }
        
        this.modulesState.current = page;
        this.setModulesState(this.modulesState);
    }

    public setSelectKeys = (arr) => {
        this.modulesState.selectedRowKeys = arr;
        this.setModulesState(this.modulesState);
        console.log(this.modulesState.selectedRowKeys);
    }
    public handleFilter = (fields) => {
        this.modulesState.fields = fields;
        this.setModulesState(this.modulesState);
    }
    /**
     * 处理请求返回结果
     * 匹配、完成、作废等操作
     * @memberof ModulesAction
     */
    public handleResult = (data, detailId?:any) => {
        // console.log(111, this.getSuccessLength(data.res));
        console.log(333, data.res.length);
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        if (this.getSuccessLength(data.res) === 0) {
            Modal.warning({
                title: '提示',
                content: '操作失败！',
                okText: '确定'
            });
        } else if (this.getSuccessLength(data.res) < data.res.length) {
            Modal.success({
                title: '提示',
                content: '部分记录未完成，请检查！',
                okText: '确定',
            });
        } else if (this.getSuccessLength(data.res) === data.res.length) {
            Modal.success({
                title: '提示',
                content: '操作成功！',
                okText: '确定',
            });

            this.modulesState.selectedRowKeys = [];
            this.setModulesState(this.modulesState);
        }
        if (this.modulesState.fields) {
            this.getList({companyId,pageSize:10, pageNum: this.modulesState.current, ...this.modulesState.fields});
        } else {
            this.getList({companyId,pageSize:10, pageNum: this.modulesState.current});
        }
    }

    /**
     * 处理结算单匹配完成
     * 
     * @memberof ModulesAction
     */
    public handleFinish = (id?: string) => {
        return new Promise((resolve:()=>void)=>{
            if (id) {
                Modal.confirm({
                    title: '提示',
                    content: '是否确认匹配完成？',
                    onOk: async()=>{
                        const data = await inputSettlement.finishMatch(this,[id]);
                        this.handleResult(data);
                        this.updateDetail(id);
                        resolve();
                    }
                });
            } else if (this.modulesState.selectedRowKeys && this.modulesState.selectedRowKeys.length > 0) {
                Modal.confirm({
                    title: '提示',
                    content: '是否确认匹配完成?',
                    onOk: async()=> {
                        const data = await inputSettlement.finishMatch(this,this.modulesState.selectedRowKeys);
                        this.handleResult(data);
                        resolve();
                    }
                });
            } else {
                this.noSelectedWarn();
                resolve();
            }
        });
        
    }

    

    /**
     * 处理结算单发送
     * 
     * @memberof ModulesAction
     */
    public handleSend = async(id?: string) => {

        if (id) {
            const data = await inputSettlement.send(this,[id]);
            this.handleResult(data);
        } else if (this.modulesState.selectedRowKeys && this.modulesState.selectedRowKeys.length > 0)  {
            Modal.confirm({
                title: '提示',
                content: '确认发送选中的单据吗？',
                onOk: async() => {
                    const data = await inputSettlement.send(this,this.modulesState.selectedRowKeys);
                    this.handleResult(data);
                    
                }
            });
        } else {
            this.noSelectedWarn();   
        }
    }

    /**
     * 处理结算单作废
     * 
     * @memberof ModulesAction
     */
    public handleInvalid = () => {
        if (this.modulesState.selectedRowKeys && this.modulesState.selectedRowKeys.length > 0)  {
            Modal.confirm({
                title: '提示',
                content: '确认作废选中的单据吗？',
                onOk: async() => {
                    const data = await inputSettlement.invalid(this,this.modulesState.selectedRowKeys);
                    this.handleResult(data);
                }
            });
        } else {
            this.noSelectedWarn();   
        }
    }


    public addMatched = (record) => {
        console.log('record', record);
        this.modulesState.matchedAmountSum += record.amount;
        this.modulesState.matchedAmountTax += record.amountTax;
        this.modulesState.matchedAmountWithoutTax += record.amountWithoutTax;
        this.modulesState.statistics.amountMatchedTolerance -= record.amount;
        this.modulesState.statistics.amountMatchedTaxTolerance -= record.amountTax;
        this.modulesState.matchedInvoiceId.push(record.incomeInvoiceBizId);
        
        this.setModulesState(this.modulesState);
    }
    public minusMatched = (record) => {
        console.log(456);
        this.modulesState.matchedAmountSum -= record.amount;
        this.modulesState.matchedAmountTax -= record.amountTax;
        this.modulesState.matchedAmountWithoutTax -= record.amountWithoutTax;

        this.modulesState.statistics.amountMatchedTolerance += record.amount;
        this.modulesState.statistics.amountMatchedTaxTolerance += record.amountTax;

        const matchedInvoiceId = this.modulesState.matchedInvoiceId;
        const index = matchedInvoiceId.indexOf(record.incomeInvoiceBizId);
        this.modulesState.matchedInvoiceId.splice(index,1);
        this.setModulesState();
    }

    /**
     * 获取已匹配发票数量
     * 
     * @memberof ModulesAction
     */
    public getMatchedLength = (arr) => {
        this.modulesState.matchedLength = arr.length;
        this.setModulesState(this.modulesState);
    }

    /**
     * 获取已匹配发票统计
     * 
     * @memberof ModulesAction
     */
    public getMatched = (arr) => {
        this.modulesState.matchedAmountSum = 0;
        this.modulesState.matchedAmountTax = 0;
        this.modulesState.matchedAmountWithoutTax = 0;
        for (let i=0; i<arr.length; i++){
            this.modulesState.matchedAmountSum += arr[i].amount;
            this.modulesState.matchedAmountTax += arr[i].amountTax;
            this.modulesState.matchedAmountWithoutTax += arr[i].amountWithoutTax;
        }
    }
    public resetMatchData=()=>{
        this.modulesState.matchedLength=0;
        this.modulesState.matchedAmountSum = 0;
        this.modulesState.matchedAmountTax = 0;
        this.modulesState.matchedAmountWithoutTax = 0;
        this.setModulesState();
    }
    /**
     * 更新结算单详情
     * 
     * @memberof ModulesAction
     */
    public updateDetail = async(params: any) =>{
        const inputSettlementDetail = await inputSettlement.getDetail(this, params);
        if(inputSettlementDetail.er){
            return ;
        }
        this.modulesState.detailInfo =  inputSettlementDetail.res;
        this.modulesState.detailList =  inputSettlementDetail.res.noticeBillDetailList;
        this.modulesState.supplierTaxId =  inputSettlementDetail.res.supplierTaxId;
        this.modulesState.statistics = inputSettlementDetail.res;
        this.setModulesState(this.modulesState);
    }
  
    /**
     * 更新结算单匹配详情
     * 
     * @memberof ModulesAction
     */
    public updateViewMatchList = async(params: any) => {
        // const inputSettlementViewMatchList = await inputSettlement.viewMatch(this,params);
        const _matchedList = await inputSettlement.viewMatch(this, params);
        const matchedList = await _matchedList.res;
        
        let matchedInvoiceList;
        this.modulesState.matchedInvoiceId.length = 0;
        for (let i = 0; i < matchedList.length; i++) {
            this.modulesState.matchedInvoiceId.push(
                matchedList[i]['invoiceBizId']
            );
        }
        if ( matchedList.length > 0 ) {
            const _matchedInvoiceList = await inputSettlement.invoiceList(this, {invoiceBizIdList:this.modulesState.matchedInvoiceId});
             matchedInvoiceList = await _matchedInvoiceList.res || [];
            this.modulesState.matchedInvoiceList = matchedInvoiceList;
            this.getMatchedLength(matchedInvoiceList);
            this.getMatched(matchedInvoiceList);
        }else{
            this.resetMatchData();
        }
        if(matchedInvoiceList){
            this.modulesState.invoiceList = [...matchedInvoiceList];
        } else {
            this.modulesState.invoiceList.length = 0;
        }
        
        
        this.setModulesState(this.modulesState);
    }
    /**
     * 更新结算单匹配列表
     * 获取匹配的发票ID
     * @memberof ModulesAction
     */
    public updateMatch = async(params: any) => {
        this.modulesState.matchedAmountSum = 0;
        this.modulesState.matchedAmountTax = 0;
        this.modulesState.matchedAmountWithoutTax = 0;
        this.modulesState.matchedLength = 0;
        //获取详情
        const inputSettlementDetail = await inputSettlement.getDetail(this, params);
        const supplierTaxId = await inputSettlementDetail.res.supplierTaxId;
        this.modulesState.detailInfo = await inputSettlementDetail.res;

        // 获取已经匹配发票
        const _matchedList = await inputSettlement.viewMatch(this, params);
        const matchedList = await _matchedList.res;
        let matchedInvoiceList;
        this.modulesState.matchedInvoiceId.length = 0;
        for (let i = 0; i < matchedList.length; i++) {
            this.modulesState.matchedInvoiceId.push(
                matchedList[i]['invoiceBizId']
            );
        }
        if ( matchedList.length > 0 ) {
            const _matchedInvoiceList = await inputSettlement.invoiceList(this, {invoiceBizIdList:this.modulesState.matchedInvoiceId});
             matchedInvoiceList = await _matchedInvoiceList.res || [];
            this.modulesState.matchedInvoiceList = matchedInvoiceList;
            this.getMatchedLength(matchedInvoiceList);
            this.getMatched(matchedInvoiceList);
        }
        if(!matchedInvoiceList) {
            matchedInvoiceList = [];
        }
        // 获取未匹配发票
        const _unmatchList = await inputSettlement.match(this, {'matchState':'UNMATCH', supplierTaxId});
        const unmatchList= await _unmatchList.res || [];
        this.modulesState.unmatchedInoviceList = unmatchList;
        this.modulesState.statistics = inputSettlementDetail.res;

        this.modulesState.invoiceList = [...matchedInvoiceList, ...unmatchList];
        this.setModulesState(this.modulesState);
    }

    public goViewMatch = (id) => {
        history.push(`/workbench/inputSettlement/viewMatch/${id}`);
    }
    public goMatch = (id) => {
        history.push(`/workbench/inputSettlement/match/${id}`);
    }

    /**
     * 进项结算单列表页
     * 未勾选数据时提示
     * @private
     * @memberof ModulesAction
     */
    private noSelectedWarn = () =>{
        Modal.info({
            title: '提示',
            content: '您未勾选数据，请检查',
            okText: '确定'
        });
    }
    /**
     * 处理返回结果
     * 统计返回正确的数据长度
     * @private
     * @memberof ModulesAction
     */
    private getSuccessLength = (arr) => {
        let num = 0;
        for (let item of arr) {
            if (Object.entries(item)[0][1] === 'true') {
                num += 1;
            }
        }
        return num;
    }

}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/Modules.Action.ts